export enum TokenSortMethod {
  INVITED = 'Invited Friends',
  REWARDS = 'Rewards',
}
